<app-authentication-manager></app-authentication-manager>
<div class="tax-page__container flex flex-column">
	<app-pub-topbar class="flex-grow-0"></app-pub-topbar>
	<router-outlet ></router-outlet>
</div>
<app-footer/>
<custom-loading-panel></custom-loading-panel>
<custom-alert/>
